import type { RadioChangeEvent } from 'antd';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Switch,
} from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfCoreSKillContext,
  UserSkillDataContext,
} from '../../../../../../../context';
import { errorHandling } from '../../../../../../../utils/helper';
import { SkillCategoryMapping } from '../../../../../../../utils/object/index';
import { SelectStringInput } from '../../../../../select-input';
import styles from './styles.module.scss';

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;

const StyledRadioButton = styled(Radio)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;

const StyledCheckedbox = styled(Checkbox)`
  .ant-checkbox-inner {
    background-color: #fff;
    border: 1px solid #d9d9d9;
  }
  .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    background-color: #4096ff;
    border-color: transparent;
  }
`;

const AddSkill: React.FC<{ setAddNew: any; skillList: any }> = ({
  setAddNew,
  skillList,
}: {
  setAddNew: any;
  skillList: any;
}) => {
  const [hasCertificate, setHasCertificate] = useState<number | string>();
  const [formData, setFormData] = useState<any>([]);
  const { userSkillData, setUserSkillData } = useContext(UserSkillDataContext);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const { numberOfCoreSkills, setNumberOfCoreSkills } = useContext(
    NumberOfCoreSKillContext
  );
  const [fields, setFields] = useState<any>([]);
  const [skillOptions, setSkillOptions] = useState<
    {
      is_checked: boolean;
      skill_id: number;
      skill_name: string;
      experience_year: string;
      level: number;
      number_of_projects: string;
      show_in_resume: boolean;
      certificate: string;
      status: number;
      profile_id?: number;
    }[]
  >([]);
  const [initialSkillOptions, setInitialSkillOptions] = useState<
    {
      is_checked: boolean;
      skill_id: number;
      skill_name: string;
      experience_year: string;
      level: number;
      number_of_projects: string;
      show_in_resume: boolean;
      certificate: string;
      status: number;
      profile_id?: number;
    }[]
  >([]);
  const [category, setCategory] = useState('');
  const [selectedSkills, setSelectedSkills] = useState<any>([]);
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);

  useEffect(() => {
    axiosInstance
      .get('/api/v1/skills/categories')
      .then((response) => {
        const options = response.data.map((cat: any) => ({
          label: SkillCategoryMapping[cat.name] || cat.name,
          value: cat.name,
        }));
        setCategoryOptions(options);
      })
      .catch((error) => {
        console.error('Failed to fetch categories', error);
      });
  }, []);

  useEffect(() => {
    if (skillList && category) {
      const filteredSkills = skillList.filter((skill: any) =>
        skill.skill_category.some((cat: any) => cat.name === category)
      );
      const formattedSkills = filteredSkills.map((skill: any) => ({
        is_checked: false,
        skill_id: skill.skill_id,
        skill_name: skill.skill_name,
        experience_year: 1,
        level: 1,
        number_of_projects: 1,
        show_in_resume: true,
        certificate: 0,
        status: 1,
      }));
      console.log('formattedSkills', formattedSkills);
      setSkillOptions(formattedSkills);
      setInitialSkillOptions(formattedSkills);
    }
  }, [category]);

  useEffect(() => {
    if (selectedSkills.length) {
      const genFields = selectedSkills.map((skillId: any, index: number) => {
        return {
          id: index,
          skill_id: skillId,
          level: '',
          experience_year: '',
          number_of_projects: '',
          certificate: 1,
          resume: '',
        };
      });
      setFields(genFields);
    }
  }, [selectedSkills]);

  const removeField = (id: number) => {
    const updatedFields = fields.filter((field: any) => field.id !== id);
    setFields(updatedFields);
  };

  const a: any = {
    skill_id: 29,
    experience_year: '1',
    level: 1,
    number_of_projects: '1',
    show_in_resume: true,
    certificate: 1,
    status: 1,
    profile_id: '644e4fb442bf085d12d97583',
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const [index, attribute] = name.split(':');
    console.log('FOrm Data', index, attribute, value, skillOptions);
    const skillIndex = skillOptions.findIndex(
      (skill) => skill.skill_id === Number(index)
    );
    console.log('skillIndex', skillIndex);
    if (skillIndex !== -1) {
      setSkillOptions((prevState) => {
        console.log('p', prevState);
        const updatedSkills = [...prevState];
        updatedSkills[skillIndex] = {
          ...updatedSkills[skillIndex],
          [attribute]: value,
        };
        console.log('up2', updatedSkills);
        return updatedSkills;
      });
    }
  };

  const handleChangeResume = (checked: boolean, skill_id: number) => {
    console.log('swithc', checked, skill_id);
    const skillIndex = skillOptions.findIndex(
      (skill) => skill.skill_id === Number(skill_id)
    );
    console.log('skillIndex', skillIndex);
    if (skillIndex !== -1) {
      setSkillOptions((prevState) => {
        console.log('p', prevState);
        const updatedSkills = [...prevState];
        updatedSkills[skillIndex] = {
          ...updatedSkills[skillIndex],
          ['show_in_resume']: checked,
        };
        console.log('up2', updatedSkills);
        return updatedSkills;
      });
    }
  };

  const handleSave = () => {
    let submitted_data;
    submitted_data = skillOptions
      .filter((skill: any) => skill.is_checked == true)
      .map((skill: any) => {
        return {
          skill_id: skill.skill_id,
          experience_year: Number(skill.experience_year),
          level: Number(skill.level),
          number_of_projects: Number(skill.number_of_projects),
          show_in_resume: skill.show_in_resume,
          certificate: skill.certificate,
          status: 1,
        };
      });

    console.log('submitted_data', submitted_data);
    if (submitted_data.length === 0) {
      return;
    }
    setIsSubmitted(true);

    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/bulk-skills';
      // requestBody['profile_id'] = employeeId;
      submitted_data = submitted_data.map((skill) => {
        return { ...skill, profile_id: employeeId };
      });
    } else {
      url = '/api/v1/profile/bulk-skills';
    }
    axiosInstance
      .post(url, submitted_data)
      .then((response) => {
        const userSkills = response.data.skills.filter(
          (skill: any) =>
            skill['status']['id'] === 1 && skill['skill_type']['id'] === 1
        );
        const orderedSkills = response.data.order_core_skills
          .map((skillId: number) =>
            userSkills.find((userSkill: any) => userSkill.skill_id === skillId)
          )
          .filter((item: any) => item !== undefined);
        setUserSkillData(orderedSkills);
        setAddNew(false);
        setNumberOfCoreSkills(userSkills.length);
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  const handleSkillChange = (value: any) => {
    setSelectedSkills(value);
  };

  const onCheckBoxChange = (e: RadioChangeEvent, skill_id: number) => {
    const { checked } = e.target;
    console.log('check', e.target.checked);
    const skillIndex = skillOptions.findIndex(
      (skill) => skill.skill_id === Number(skill_id)
    );
    console.log('skillIndex', skillIndex);
    if (skillIndex !== -1) {
      setSkillOptions((prevState) => {
        console.log('p', prevState);
        const updatedSkills = [...prevState];
        updatedSkills[skillIndex] = {
          ...updatedSkills[skillIndex],
          ['is_checked']: checked,
        };
        console.log('up2', updatedSkills);
        return updatedSkills;
      });
    }
  };

  const handleCategoryChange = (val: any) => {
    const skillOptionsChanged =
      JSON.stringify(skillOptions) !== JSON.stringify(initialSkillOptions);
    if (skillOptionsChanged) {
      const confirmChange = window.confirm(
        'Changing the category will discard unsaved changes. Are you sure you want to proceed?'
      );
      if (confirmChange) {
        setCategory(val);
      }
    } else {
      setCategory(val);
    }
  };

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row className={styles.row}>
          <Col span={12} style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label style={{ width: '200px' }} htmlFor="skillSelect">
                Select Skill Category:
              </label>
              <Select
                id="skillSelect"
                placeholder="Select a skill category"
                onChange={(val: any) => handleCategoryChange(val)}
                options={categoryOptions}
                style={{ width: '100%' }}
              />
            </div>
          </Col>

          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Row>
                  <Col span={3}>
                    <span className={styles.title}>Skills</span>
                  </Col>
                  <Col span={3}>
                    <span className={styles.title}>Level</span>
                  </Col>
                  <Col span={4}>
                    <span className={styles.title}>Experiences (Years)</span>
                  </Col>
                  <Col span={4}>
                    <span className={styles.title}>No. of Projects</span>
                  </Col>
                  <Col span={4}>
                    <span className={styles.title}>Certificates</span>
                  </Col>
                  <Col span={6}>
                    <span className={styles.title}>Show in Resume</span>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                {skillOptions.map((field: any, index: number) => (
                  <Row key={field.index}>
                    <Col span={3}>
                      <StyledCheckedbox
                        style={{}}
                        onChange={(e) => onCheckBoxChange(e, field.skill_id)}
                        name={`${field.skill_id}:is_checked`}
                      >
                        {field.skill_name}
                      </StyledCheckedbox>
                    </Col>
                    <Col span={3}>
                      <p>
                        <select
                          defaultValue={field.level}
                          onChange={handleChange}
                          name={`${field.skill_id}:level`}
                          style={{
                            width: '60px',
                            borderRadius: '4px',
                            borderColor: '#d5d5d5',
                          }}
                        >
                          {[...Array(10)].map((_, levelIndex) => (
                            <option key={levelIndex + 1} value={levelIndex + 1}>
                              {levelIndex + 1}
                            </option>
                          ))}
                        </select>
                      </p>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        name={`${field.skill_id}:experience_year`}
                        label=""
                      >
                        <p>
                          <Input
                            className={styles.input}
                            value={field.experience_year}
                            onChange={handleChange}
                            name={`${field.skill_id}:experience_year`}
                            style={{
                              borderBottom:
                                `experience_year_${field.skill_name}` in
                                errorMessage
                                  ? '1px solid red'
                                  : '',
                            }}
                          />
                        </p>
                      </Form.Item>
                      <Row>
                        <p style={{ color: 'red' }}>
                          {`experience_year_${field.skill_name}` in errorMessage
                            ? errorMessage[
                                `experience_year_${field.skill_name}`
                              ]
                            : ''}
                        </p>
                      </Row>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        name={`${field.skill_id}:number_of_projects`}
                        label=""
                      >
                        <p>
                          <Input
                            className={styles.input}
                            onChange={handleChange}
                            value={field.number_of_projects}
                            name={`${field.skill_id}:number_of_projects`}
                            required
                            style={{
                              borderBottom:
                                `number_of_projects_${field.skill_name}` in
                                errorMessage
                                  ? '1px solid red'
                                  : '',
                            }}
                          />
                        </p>
                      </Form.Item>
                      <Row>
                        <p style={{ color: 'red' }}>
                          {`number_of_projects_${field.skill_name}` in
                          errorMessage
                            ? errorMessage[
                                `number_of_projects_${field.skill_name}`
                              ]
                            : ''}
                        </p>
                      </Row>
                    </Col>
                    <Col span={5}>
                      <p>
                        <Radio.Group
                          onChange={handleChange}
                          name={`${field.skill_id}:certificate`}
                          value={field.certificate}
                        >
                          <Radio value={1}>Yes</Radio>
                          <Radio value={0}>No</Radio>
                        </Radio.Group>
                      </p>
                    </Col>
                    <Col span={5}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Switch
                          defaultChecked
                          onChange={(e) =>
                            handleChangeResume(e, field.skill_id)
                          }
                        />
                        {/* <span>Show in resume</span> */}
                      </div>
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>

            {/* <Row justify="end" style={{ marginBottom: 10 }}>
              <Col>
                <PlusOutlined onClick={handleAddField} style={{ fontSize: 20, cursor: 'pointer' }} />
              </Col>
            </Row> */}
          </Col>
        </Row>

        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              // disabled={
              //   // !skillValue ||
              //   // !levelValue ||
              //   !formData['experience_year'] || !formData['number_of_projects']
              // }
            >
              Save
            </Button>
          </Form.Item>

          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setAddNew(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default AddSkill;
